<ng-template cvDynamicContent></ng-template>
<div class="notification text-center" 
	[style.width.px]="notificationWidth"
	[@showHide]="{value: displayNotification ? 'show' : 'hide'}">
	{{notificationMessage}}
</div>
